import React from "react";
import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import {
  SiMarkdown,
  SiJavascript,
  SiMui,
  SiTailwindcss,
  SiFigma,
  SiCanva,
  SiNextdotjs,
  SiTypescript,
} from "react-icons/si";
import { RiReactjsFill } from "react-icons/ri";
import { FaWordpress } from "react-icons/fa6";

const iconData = [
  { label: "Markdown", icon: <SiMarkdown />, color: "#000000" },
  { label: "JavaScript", icon: <SiJavascript />, color: "#F7DF1E" },
  { label: "TypeScript", icon: <SiTypescript />, color: "#3178c6" },
  { label: "React.js", icon: <RiReactjsFill />, color: "#61DAFB" },
  { label: "Next.js", icon: <SiNextdotjs />, color: "#000000" },
  { label: "Wordpress", icon: <FaWordpress />, color: "#ffffff" },
  { label: "Tailwind CSS", icon: <SiTailwindcss />, color: "#06B6D4" },
  { label: "Material UI", icon: <SiMui />, color: "#007FFF" },
  { label: "Figma", icon: <SiFigma />, color: "#000000" },
  { label: "Canva", icon: <SiCanva />, color: "#00C4CC" },
];

export default function CodeStack() {
  return (
    <Box>
      <Typography
        sx={{ textAlign: "left", mb: 2, fontWeight: "bolder", fontSize: 30 }}
      >
        🪄 Stack
      </Typography>

      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
        sx={{
          "& > :not(style) + :not(style)": { marginLeft: 2 },
          mt: 2,
          textAlign: "center",
        }}
      >
        {iconData.map((item, index) => (
          <Tooltip key={index} title={item.label}>
            <IconButton aria-label={item.label}>
              {React.cloneElement(item.icon, { color: item.color })}
            </IconButton>
          </Tooltip>
        ))}
      </Grid>
    </Box>
  );
}
